import { render } from "./HeroNotFoundDataGrid.vue?vue&type=template&id=38e60252&scoped=true"
import script from "./HeroNotFoundDataGrid.vue?vue&type=script&lang=js"
export * from "./HeroNotFoundDataGrid.vue?vue&type=script&lang=js"

import "./HeroNotFoundDataGrid.vue?vue&type=style&index=0&id=38e60252&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e60252"]])

export default __exports__